<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 17:54:29
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-08-15 16:51:41
-->
<template>
  <div class="index-video posrel">
    <video
      ref="indexVideo"
      muted
      loop
      preload="none"
      x5-playsinline="true"
      playsinline="true"
      webkit-playsinline="true"
      x5-video-player-type="h5"
      :src="require('@/assets/video/index.mp4')"
      :poster="require('@/assets/images/index/videobj.png')"
      @click="playBtn = !playBtn">
      <source :data-layzr-src="require('@/assets/video/index.mp4')" type="video/mp4">
    </video>
    <svg-icon v-if="isAndroid && playBtn" :icon-class="playStatus ? 'pause' : 'bofang'" class="play" @click.native.stop="setPlayVideo()" />
    <div v-show="!canplay" class="loader">
      <div class="inner one"></div>
      <div class="inner two"></div>
      <div class="inner three"></div>
    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { isBrowser } from '@/utils'
export default {
  data () {
    return {
      canplay: false, // 准备状态
      playStatus: false,
      playBtn: false,
      isAndroid: window.navigator.userAgent.indexOf('Android') !== -1
    }
  },
  mounted () {
    // const _this = this
    if (isBrowser() === 'wechat') {
      if (this.isAndroid) {
        // this.canplay
        document.addEventListener('WeixinJSBridgeReady', () => {
          this.canplay = true
          this.playBtn = true
        }, false)
        // android 触屏播放视频
        // document.addEventListener('touchstart', this.setPlay, false)
        // document.getElementsByTagName('body')[0].onclick = function () {
        //   console.log(111)
        //   _this.setPlay()
        // }
      } else {
        /**
         * 解决ios微信浏览器视频不自动播放
         */
        var voice = this.$refs.indexVideo
        if (typeof window.WeixinJSBrdgeReady === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
          this.canplay = true
          voice.play()
        } else {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.setPlay, false)
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.setPlay)
            document.attachEvent('onWeixinJSBridgeReady', this.setPlay)
          }
        }
      }
    } else {
      this.$refs.indexVideo.play()
      this.$refs.indexVideo.oncanplay = () => {
        this.canplay = true
      }
    }
  },
  methods: {
    setPlay () {
      const voice = this.$refs.indexVideo
      this.canplay = true
      voice.play()
    },
    setPlayVideo () {
      const voice = this.$refs.indexVideo
      this.playStatus ? voice.pause() : voice.play()
      this.playStatus = !this.playStatus
      this.playBtn = !this.playStatus
    }
  },
  beforeDestroy () {
    document.removeEventListener('touchstart', this.setPlay, false)
    if (document.addEventListener) {
      document.removeEventListener('touchstart', this.setPlay, false)
    } else if (document.attachEvent) {
      document.detachEvent('WeixinJSBridgeReady', this.setPlay)
      document.detachEvent('onWeixinJSBridgeReady', this.setPlay)
    }
  }
}
</script>

<style lang="less" scoped>
.m .index-video {
  background: #000000;
  height: 420px;
  video{
    width: 100%;
    object-fit: fill;
    display: block;
    height: 420px;
    margin-bottom: -3PX;
  }
  .play {
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    perspective: 800px;
    font-size: 100px;
    color: #ffffff;
  }
  .loader {
    position: absolute;
    top: calc(50% - 32px);
    left: calc(50% - 32px);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    perspective: 800px;
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .inner.one {
    left: 0%;
    top: 0%;
    animation: rotate-one 1s linear infinite;
    border-bottom: 3px solid #EFEFFA;
  }

  .inner.two {
    right: 0%;
    top: 0%;
    animation: rotate-two 1s linear infinite;
    border-right: 3px solid #EFEFFA;
  }

  .inner.three {
    right: 0%;
    bottom: 0%;
    animation: rotate-three 1s linear infinite;
    border-top: 3px solid #EFEFFA;
  }

  @keyframes rotate-one {
    0% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-two {
    0% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-three {
    0% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
    }
  }
}
</style>
